import { BrandKitTemplateResponse } from '@goldcast/api/content';

const SESSION_STORAGE_FTUX_CONFIG_KEY = 'ftux_configs';

export type FTUXConfig = {
  color?: string;
  /**
   * Full list of custom brand colours chosen in the simplified upload flow. `color` stays the
   * first of these for backward compatibility with the current backend, which reads a single
   * colour; `colours` carries the rest for Phase 2 to consume.
   */
  colours?: string[];
  font_location?: string;
  templates?: BrandKitTemplateResponse[];
};

export const getLocalFtuxConfig = (contentId?: string): FTUXConfig | undefined => {
  if (!contentId) {
    return undefined;
  }

  return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_FTUX_CONFIG_KEY) || '{}')[contentId || ''] as FTUXConfig;
};

export const storeLocalFtuxConfig = (contentId: string, config: FTUXConfig) => {
  const localFtuxConfig = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_FTUX_CONFIG_KEY) || '{}');
  localFtuxConfig[contentId] = config;
  sessionStorage.setItem(SESSION_STORAGE_FTUX_CONFIG_KEY, JSON.stringify(localFtuxConfig));
};
